module.exports = __webpack_public_path__ + "img/20200409144010TIM截图20200409142358.557bcfe1.png";